import { PAGES } from "redux/actions/pages/constants";

// feature name
export const BULK_ASSIGNMENT = `${PAGES} [BulkAssignment]`;

// action types
export const GET_BULK_ASSIGNMENT_CLASSES = `${BULK_ASSIGNMENT} GET_CLASSES`;
export const PREVIEW_BULK_ASSIGNMENT = `${BULK_ASSIGNMENT} PREVIEW`;
export const SAVE_BULK_ASSIGNMENT = `${BULK_ASSIGNMENT} SAVE`;
export const CLEAR_BULK_ASSIGNMENT = `${BULK_ASSIGNMENT} CLEAR`;

// action creators
export const getBulkAssignmentClasses = () => ({
  type: GET_BULK_ASSIGNMENT_CLASSES,
});

export const previewBulkAssignment = ({ classIds, bookId }) => ({
  type: PREVIEW_BULK_ASSIGNMENT,
  payload: { classIds, bookId },
});

export const saveBulkAssignment = ({ assignment }) => ({
  type: SAVE_BULK_ASSIGNMENT,
  payload: { assignment },
});

export const clearBulkAssignment = () => ({
  type: CLEAR_BULK_ASSIGNMENT,
});
